import { GridCellProps } from "@progress/kendo-react-grid";
import { formatDate } from "@telerik/kendo-intl";
import { GridRowClickProps, OnRowClickType } from "../GridRowClickProps";
import { kendoDefaultDateFormatddMMyyyy } from "../../../Utils/dates";

type DateCellProps = {
  defaultForEmptyValue?: string;
  dateFormat?: string;
};

export function DateCell({
  dataItem,
  field,
  onRowClick,
  defaultForEmptyValue,
  dateFormat,
}: GridCellProps & GridRowClickProps & DateCellProps) {
  const myField = field || "";
  const dataValue = !dataItem[myField] ? "" : dataItem[myField];

  const formattedDate = !dataValue.valueOf()
    ? defaultForEmptyValue
    : formatDate(new Date(dataValue), dateFormat ?? kendoDefaultDateFormatddMMyyyy);

  return <td onClick={() => onRowClick(dataItem)}>{formattedDate}</td>;
}

export const kendoDateCell = (
  onRowClick?: OnRowClickType,
  defaultForEmptyValue?: string,
  dateFormat?: string
) =>
  function KendoDateCell(props: GridCellProps & DateCellProps) {
    return (
      <DateCell
        {...props}
        onRowClick={onRowClick ?? (() => undefined)}
        defaultForEmptyValue={defaultForEmptyValue ?? ""}
        dateFormat={dateFormat}
      />
    );
  };
